export default {
    methods: {
        decodeBase64(string) {
            var e = {}, i, b = 0, c, x, l = 0, a, r = '', w = String.fromCharCode, L = string.length;
            var A = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
            for (i = 0; i < 64; i++) {
                e[A.charAt(i)] = i;
            }
            for (x = 0; x < L; x++) {
                c = e[string.charAt(x)];
                b = (b << 6) + c;
                l += 6;
                while (l >= 8) {
                    ((a = (b >>> (l -= 8)) & 0xff) || (x < (L - 2))) && (r += w(a));
                }
            }
            return r;
        },
        isEmpty(data) {
            if (typeof data === 'string') {
                return !!(!data);
            } else {
                if (data instanceof Array) {
                    return !!(!data.length);
                } else {
                    return !!(Object.keys(data).length === 0 && data.constructor === Object);
                }
            }
        },
        pluck(array, key) {
            return array.map(function (value) {
                return value[key];
            });
        },
        at(array, key) {
            if (typeof array[key] !== 'undefined') {
                return array[key];
            }

            return array;
        },
        minArray(array) {
            return Math.min(...array);
        },
        maxArray(array) {
            return Math.max(...array);
        },
        shuffle(array) {
            for (let i = array.length - 1; i > 0; i--) {
                let j = Math.floor(Math.random() * (i + 1));
                let temp = array[i];
                array[i] = array[j];
                array[j] = temp;
            }
            return array;
        },
        first(array) {
            if (Array.isArray(array)) {
                return array[0];
            }

            return array;
        },
        last(array) {
            if (Array.isArray(array)) {
                return array[array.length - 1];
            }

            return array;
        },
        without(array, exclude) {
            return array.filter(function (element) {
                return !exclude.includes(element);
            });
        },
        unique(array) {
            return array.filter(function (element, index, self) {
                return index == self.indexOf(element);
            });
        },

        checkNested(obj) {
            let args = Array.prototype.slice.call(arguments, 1);

            for (let i = 0; i < args.length; i++) {
                if (!obj || !obj.hasOwnProperty(args[i])) {
                    return false;
                }

                obj = obj[args[i]];
            }

            return true;
        }
    }
};
